import styled, { css } from 'styled-components';
import Button from '../../ui/Button';
import { Col } from '../../styled';
import { contentWidthMedia } from '../../styled/utils';

export const MarketButtonsCol = styled(Col)`
    width: ${({ $showOUMarkets }) => ($showOUMarkets ? '60%' : '100%')};
`;

export const MarketButtonsRow = styled.div`
    display: flex;
    gap: 4px;
`;

export const MarketButtonStyled = styled(Button)`
    padding: 12px 4px;
    max-height: 42px;
    height: 42px;
    font-size: 13px;
    font-weight: 700;
    line-height: 18px;
    margin: 0;
    white-space: nowrap;
    min-width: 48px;
    width: 100%;
    transition: all 0.3s ease;

    ${({ disabled }) =>
        disabled &&
        css`
            border: 1px solid ${({ theme }) => theme.borders.neutralBorder};
            background: ${({ theme }) => theme.bg.neutralGrey};
            color: ${({ theme }) => theme.text.neutralLightSemiGrey};

            .bet-label {
                color: ${({ theme }) => theme.text.neutralLightSemiGrey};
            }
        `};

    ${({ $contentWidth }) => {
        const media = contentWidthMedia($contentWidth);

        return css`
            ${media.lessThan(
                700,
                css`
                    padding: 12px 5px;
                `
            )};
        `;
    }};
`;

export const OUMarketButtonsCol = styled(Col)`
    min-width: 155px;
    width: 40%;
`;

export const OUMarketButtonStyled = styled(MarketButtonStyled)`
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    gap: 4px;
    min-width: 75px;

    .noOdds {
        width: 100%;
        text-align: center;
    }

    ${({ $contentWidth }) => {
        const media = contentWidthMedia($contentWidth);

        return css`
            ${media.lessThan(
                880,
                css`
                    padding: 12px 12px;
                `
            )};

            ${media.lessThan(
                750,
                css`
                    padding: 12px 8px;
                `
            )};
        `;
    }};
`;
